import { render, staticRenderFns } from "./supportTickets.vue?vue&type=template&id=9b85afa4&"
import script from "./supportTickets.vue?vue&type=script&lang=js&"
export * from "./supportTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports